import { render, staticRenderFns } from "./CateringServicesTable.vue?vue&type=template&id=7f109e26&"
import script from "./CateringServicesTable.vue?vue&type=script&lang=js&"
export * from "./CateringServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports